exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".drop-area[data-v-153bd5c2]{background:rgba(0,0,0,.02);text-align:center;border:2px dashed #007bff;border-radius:5px;min-height:10em;cursor:pointer;transition:all .3s ease}.drop-area>.drop-area-content[data-v-153bd5c2]{height:100%;width:100%;pointer-events:none;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-153bd5c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/upload-file/upload-file-target.vue
// module id = 117
// module chunks = 0